import { call, put } from 'redux-saga/effects';

import { creators as AdminActions } from '../../Reducers/Admin';
import Api from '../../Api/DefaultApi';

export function* getAllCompanies() {
  try {
    const response = yield call(Api.getAllCompanies, null);
    if (response.status === 200) {
      yield put(AdminActions.adminSuccess({ companies: response.data }));
    } else {
      yield put(AdminActions.adminFailure(response.message));
    }
  } catch (e) {
    yield put(AdminActions.adminFailure(e));
  }
}
